"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _useSelectable2 = require("b2b-components/hooks/useSelectable");
var _Selectable = require("../Selectable");
var _excluded = ["defaultValue", "isDisabled", "isMultiple", "onChange", "render", "value"];
var WithContainer = function WithContainer(_ref) {
  var defaultValue = _ref.defaultValue,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$isMultiple = _ref.isMultiple,
    isMultiple = _ref$isMultiple === void 0 ? true : _ref$isMultiple,
    onChange = _ref.onChange,
    render = _ref.render,
    value = _ref.value,
    originalProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useSelectable = (0, _useSelectable2.useSelectable)(defaultValue, value, onChange, isMultiple),
    isOptionChecked = _useSelectable.isOptionChecked,
    onOptionChange = _useSelectable.onOptionChange;
  var addProps = {
    children: render({
      isDisabled: isDisabled || false,
      isOptionChecked: isOptionChecked,
      onOptionChange: onOptionChange
    })
  };
  return /*#__PURE__*/_react["default"].createElement(_Selectable.Selectable, (0, _extends2["default"])({}, originalProps, addProps));
};
exports.WithContainer = WithContainer;